<template>
  <div class="row">
    <div v-if="!!filter" class="col-12 p-0">
      <collapse :multiple-active="false">
        <collapse-item title="Filtros">
          <component :is="filter" @handleRead="handleRead"></component>
        </collapse-item>
      </collapse>
    </div>
    <div class="col-12">
      <div>
        <div v-if="queriedData.length" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <el-select v-if="with_pagination" class="select-primary mb-3" style="width: 200px" v-model="pagination.perPage"
            placeholder="Per page" @change="handleReadPagination">
            <el-option class="select-default" v-for="item in pagination.perPageOptions" :key="item" :label="item"
              :value="item">
            </el-option>
          </el-select>
          <fg-input v-if="with_search_input">
            <el-input type="search" class="mb-3" clearable prefix-icon="el-icon-search" style="width: 200px"
              placeholder="Pesquisa" v-model="searchQuery" aria-controls="datatables">
            </el-input>
          </fg-input>
        </div>
        <div v-if="!loading">
          <el-table v-if="queriedData.length" stripe style="width: 100%" :data="queriedData" :showHeader="true">
            <!-- <table-header :headers="table_headers"></table-header> -->
            <el-table-column v-for="column in table_columns" :key="column.label" :min-width="column.minWidth"
              :prop="column.type === 'nested' ? '' : column.prop" :label="column.label">
              <div v-if="column.prop !== 'actions'" slot-scope="props" style="max-width: 100%" :class="column.class">
                <span v-if="column.type === 'detail'" @click="openDetailModal(props.row)" class="detail-icon">
                  <i class="fas fa-eye"></i>
                </span>
                <span v-if="column.type === 'text'" :title="`${column.truncate ? props.row[column.prop] : ''}`">
                  {{
                    (column.truncate && props.row[column.prop].length > column.max_char)
                    ? props.row[column.prop].substring(0, column.max_char) + "..."
                    : props.row[column.prop]
                  }}
                </span>
                <span v-if="column.type === 'nested'" :title="`${column.truncate ? nested_column(props.row, column.prop) : ''
                  }`">
                  {{
                    column.truncate
                    ? nested_column(props.row, column.prop).substring(
                      0,
                      column.max_char
                    ) + "..."
                    : nested_column(props.row, column.prop)
                  }}
                </span>
                <span v-if="column.type === 'money'">
                  {{ props.row[column.prop] ?? 0.0 | formatMoney }}
                </span>
                <span v-if="column.type === 'bool'">
                  <i :class="`now-ui-icons ${props.row[column.prop]
                    ? 'ui-1_check text-success'
                    : 'ui-1_simple-remove text-danger'
                    }`"></i>
                </span>
                <span v-if="column.type === 'date'">
                  {{
                    props.row[column.prop] ? toLLT(props.row[column.prop]) : ""
                  }}
                </span>
                <img v-if="column.type === 'image'" :src="props.row[column.prop]" :style="`width: ${column.width ?? 100}px; height: ${column.height ?? 100
                  }px;`" />
              </div>
              <div v-else slot-scope="props" class="table-actions d-flex justify-content-center">
                <n-button v-if="actions.find((e) => e.method === 'detail').route_name !== ''"
                  @click.native="handleDetail(props.row, actions, false)" class="detail" type="primary" size="sm" round
                  icon tooltip="Abrir detalhes">
                  <i class="fa fa-eye"></i>
                </n-button>
                <n-button v-if="actions.find((e) => e.method === 'detail').route_name !== ''"
                  @click.native="handleDetail(props.row, actions, true)" class="detail" type="primary" size="sm" round
                  icon tooltip="Abrir detalhes em nova guia">
                  <i class="fa fa-external-link-alt"></i>
                </n-button>
                <n-button v-if="actions.find((e) => e.method === 'update').route_name !== ''
                  " @click.native="handleEdit(props.row, actions)" class="edit" type="secondary" size="sm" round icon
                  tooltip="Editar">
                  <i class="fa fa-pen"></i>
                </n-button>
                <n-button v-if="actions.find((e) => e.method === 'generate_order').active
                  " @click.native="handleGenerateOrder(props.row)" type="success" size="sm" round icon
                  tooltip="Gerar pedido">
                  <i class="now-ui-icons shopping_cart-simple"></i>
                </n-button>
                <n-button v-if="actions.find((e) => e.method === 'change_order_status')
                  .active && !is_customer
                  " @click.native="handleChangeOrderStatus(props.row)" type="warning" size="sm" round icon
                  tooltip="Alterar status">
                  <i class="now-ui-icons design_bullet-list-67"></i>
                </n-button>
                <n-button v-if="actions.find((e) => e.method === 'destroy').route !== ''
                  " @click.native="handleDelete(props.row, actions)" class="remove" type="danger" size="sm" round icon
                  tooltip="Remover">
                  <i class="fa fa-trash"></i>
                </n-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="d-flex justify-content-center my-5">
          <div v-if="!loading && !table.data.length">
            <p>{{ emptyMsg }}</p>
          </div>
          <loader v-else></loader>
        </div>
      </div>
      <div v-if="with_pagination" slot="footer"
        class="mt-5 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div v-if="queriedData.length" class="d-flex align-items-center">
          <p class="card-category">
            Mostrando {{ from }} até {{ to }} de {{ total }} registros.
          </p>
        </div>
        <n-pagination v-if="queriedData.length" class="pagination-no-border" v-model="pagination.currentPage"
          :per-page="pagination.perPage" :total="total" :back_pagination="raw_data" @handleRead="handleReadPagination">
        </n-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import {
  Collapse,
  CollapseItem,
  Pagination as NPagination,
  Loader
} from "@/components";
import swal from "sweetalert2";
import TableHeader from './TableHeader.vue';

import filter_budgets from "./filters/filterBudgets.vue";
import filter_orders from "./filters/filterOrders.vue";
import filter_customers from "./filters/filterCustomers.vue";
import filter_products from "./filters/filterProducts.vue";

export default {
  props: {
    raw_data: {
      type: Array | Object,
      required: true,
    },
    table_columns: {
      type: Array,
      required: true,
    },
    props_to_search: {
      type: Array,
      default: () => [],
      required: false,
    },
    edit_mode: {
      type: Boolean,
      default: false,
      required: false,
    },
    with_pagination: {
      type: Boolean,
      default: true,
      required: false,
    },
    with_search_input: {
      type: Boolean,
      default: true,
      required: false,
    },
    actionsProp: {
      type: Array,
      default: () => [],
      required: false,
    },
    filter: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Collapse,
    CollapseItem,
    // Filters
    filter_budgets,
    filter_orders,
    filter_customers,
    filter_products,
    NPagination,
    Loader,
    'table-header': TableHeader,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.raw_data.data;
      if (this.raw_data.paginate) {
        this.pagination.perPage = this.raw_data.per_page;
        this.pagination.currentPage = this.raw_data.current_page;
        return result;
      } else if (!this.with_pagination) {
        return result;
      }

      return result.slice(this.from, this.to);
    },
    to() {
      if (this.raw_data.paginate) {
        return this.raw_data.to;
      }
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      if (this.raw_data.paginate) {
        return this.raw_data.from;
      }
      return this.pagination.perPage * (this.pagination.currentPage - 1) + 1;
    },
    total() {
      if (this.raw_data.paginate) {
        return this.raw_data.total;
      }
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.raw_data.length;
    },
    actions() {
      return this.actionsProp;
    },
    table_headers() {
      return this.table_columns.map((column) => {
        return {
          name: column.label,
          minWidth: column.minWidth,
          class: column.class,
          prop: column.prop
        };
      });
    }
  },
  watch: {
    pagination: {
      handler() { },
      deep: true,
    },
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 15, 25, 50, 75, 100],
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      url_filter: false,
      url_params: null,
      openingNewTab: false
    };
  },
  created() { },
  methods: {
    nested_column(row, column) {
      let value;
      // Garantindo que a tabela não vai tentar acessar um objeto null/undefined e crashar
      switch (true) {
        case column.length === 2:
          value = row[column[0]] ? row[column[0]][column[1]] : "---";
          break;
        case column.length === 3:
          if (row[column[0]]) {
            if (row[column[0]][column[1]]) {
              value = row[column[0]][column[1]][column[2]];
              break;
            }
          }
          value = "---";
          break;
        case column.length === 4:
          if (row[column[0]]) {
            if (row[column[0]][column[1]]) {
              if (row[column[0]][column[1]][column[2]]) {
                value = row[column[0]][column[1]][column[2]][column[3]];
                break;
              }
            }
          }
          value = "---";
          break;
        case column.length === 5:
          if (row[column[0]]) {
            if (row[column[0]][column[1]]) {
              if (row[column[0]][column[1]][column[2]]) {
                if (row[column[0]][column[1]][column[2]][column[3]]) {
                  value =
                    row[column[0]][column[1]][column[2]][column[3]][column[4]];
                  break;
                }
              }
            }
          }
          value = "---";
          break;
        case column.length === 6:
          if (row[column[0]]) {
            if (row[column[0]][column[1]]) {
              if (row[column[0]][column[1]][column[2]]) {
                if (row[column[0]][column[1]][column[2]][column[3]]) {
                  if (
                    row[column[0]][column[1]][column[2]][column[3]][column[4]]
                  ) {
                    value =
                      row[column[0]][column[1]][column[2]][column[3]][
                      column[4]
                      ][column[5]];
                    break;
                  }
                }
              }
            }
          }
          value = "---";
          break;
        default:
          break;
      }
      return value;
    },
    handleEdit(row, actions) {
      let action = actions.find((e) => e.method === "update");
      if (action.modal) {
        let value = row.kit_info ? row.kit_info.quantity : row.quantity;
        swal({
          title: "Editar",
          html: `<div class="form-group">
            <input id="swal-input-field" type="number" value=${value} class="text-dark form-control" />
            </div>`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false,
        })
          .then(async (response) => {
            if (response.value) {
              let input = document.getElementById("swal-input-field");
              let value = input.value;
              let response = await this.$store.dispatch(
                `${action.route_name}`,
                {
                  optional_id: action.optional_id,
                  product_id: row.id,
                  quantity: Number(value),
                }
              );
              this.$emit("sendDataProp", response.data);
              swal({
                type: "success",
                html: `Valor alterado com sucesso!`,
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              });
            }
          })
          .catch(swal.noop);
      } else {
        this.$router.push({ name: action.route_name, params: { id: row.id } });
      }
    },
    handleDelete(row, actions) {
      swal({
        title: "Tem certeza?",
        text: `Você não poderá reverter essa ação!`,
        type: "warning",
        showCancelButton: true,
        cancelButtonClass: "btn btn-danger btn-fill",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "Sim, deletar!",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await this.deleteRow(row, actions);
          let action = actions.find((e) => e.method === "destroy");
          if (!!action.optional_id) {
            this.$emit("sendDataProp", response.data);
            swal({
              title: "Deletado!",
              text: "Registro deletado com sucesso.",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          } else {
            this.$emit("getData");
            if (response) {
              swal({
                title: "Deletado!",
                text: "Registro deletado com sucesso.",
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              });
            }
          }
        }
      });
    },
    async deleteRow(row, actions) {
      let action = actions.find((e) => e.method === "destroy");
      if (!!action.optional_id) {
        return await this.$store.dispatch(`${action.route}/destroy`, {
          optional_id: action.optional_id,
          id: row.id,
        });
      } else {
        return await this.$store.dispatch(`${action.route}/destroy`, row.id);
      }
    },
    handleDetail(row, actions, newTab) {
      let action = actions.find((e) => e.method === "detail");

      if (!newTab) {
        this.$router.push({ name: action.route_name, params: { id: row.id } });
      } else {
        const routeData = this.$router.resolve({ name: action.route_name, params: { id: row.id } });
        window.open(routeData.href, '_blank');
      }
    },
    handleRead(val) {
      if (this.raw_data.paginate) {
        this.url_filter = val.url_filter ?? false;
        this.url_params = val.url_params ?? null;
        this.$emit("getData", {
          pagination: { ...this.pagination, ...val?.pagination },
          url_filter: val?.url_params !== null ? val?.url_filter : false,
          url_params: val?.url_params,
        });
      }
    },
    handleReadPagination(val) {
      let params = {
        pagination: val,
        url_filter: !!this.url_params !== null ? this.url_filter : false,
        url_params: this.url_params ?? null,
      };
      this.handleRead(params);
    },
    async handleChangeOrderStatus(row) {
      let status = await this.$store.dispatch("order/status");
      let options = status.map((e) => {
        return "<option value=" + e.id + ">" + e.name + "</option>";
      });
      swal({
        title: "Alterar status",
        html: `
        <div class="">
          <select id="swal-select-status" type="number" class="text-dark form-control">
            ${options}
          </select>
        </div>`,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false,
      }).then(async (response) => {
        if (response.value) {
          let status_id = document.getElementById("swal-select-status");
          await this.$store.dispatch("order/update", {
            id: row.id,
            params: { status_id: status_id.value },
          });
          this.$emit("getData");
        }
      });
    },
    async handleGenerateOrder(row) {
      swal({
        title: "Gerar Pedido",
        html: `<p><b>Orçamento ${row.kit.name} - ${row.power}</b></p>`,
        showCancelButton: true,
        confirmButtonText: "Gerar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false,
      }).then(async (response) => {
        if (response.value) {
          this.$store
            .dispatch("order/create", { budget_id: row.id })
            .then((order_id) => {
              this.$router.push({
                name: "Detalhes de Pedido",
                params: { id: order_id },
              });
            });
        } else {
        }
      });
    },
    openDetailModal(product) {
      this.$emit("openDetailModal", product);
    }
  },
};
</script>
<style lang="scss">
@import "src/assets/sass/now-ui-dashboard/variables.scss";

.detail-icon {
  width: 100%;
  height: 100%;

  cursor: pointer;

  &:hover {
    i {
      color: $secondary-color;
    }
  }

  i {
    font-size: 1rem;
    color: $white-color;
  }
}
</style>
